module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', {
    attrs: {
      "title": "修改邮箱",
      "align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/user/BaseInfo"
    },
    slot: "left"
  }, [_c('mu-icon', {
    staticStyle: {
      "margin-top": "1vh"
    },
    attrs: {
      "value": "keyboard_arrow_left",
      "color": "white"
    }
  })], 1), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "90%",
      "margin-top": "2vh"
    },
    attrs: {
      "align": "center",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "title",
    staticStyle: {}
  }, [_vm._v("\n\n        新邮箱\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "1vh",
      "width": "103%"
    },
    attrs: {
      "hintText": "gxx@qq.com",
      "type": "text",
      "fullWidth": ""
    },
    model: {
      value: (_vm.UserEmail),
      callback: function($$v) {
        _vm.UserEmail = $$v
      },
      expression: "UserEmail"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title",
    staticStyle: {}
  }, [_vm._v("\n        附加码\n      ")]), _vm._v(" "), _c('td', [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "1vh",
      "width": "98%"
    },
    attrs: {
      "hintText": "2333",
      "type": "text",
      "fullWidth": ""
    },
    model: {
      value: (_vm.FJM),
      callback: function($$v) {
        _vm.FJM = $$v
      },
      expression: "FJM"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n      \n        2232\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title",
    staticStyle: {}
  }, [_vm._v("\n        验证码\n      ")]), _vm._v(" "), _c('td', [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "1vh",
      "width": "98%"
    },
    attrs: {
      "hintText": "2333",
      "type": "text",
      "fullWidth": ""
    },
    model: {
      value: (_vm.YZM),
      callback: function($$v) {
        _vm.YZM = $$v
      },
      expression: "YZM"
    }
  })], 1), _vm._v(" "), _c('td', [_c('mu-raised-button', {
    staticStyle: {
      "font-size": "110%",
      "margin-left": "2%",
      "width": "27%",
      "margin-bottom": "3vh"
    },
    attrs: {
      "label": "获取",
      "primary": ""
    },
    on: {
      "click": _vm.getYZM
    }
  })], 1)])]), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "130%",
      "margin-top": "2vh"
    },
    style: ({
      width: '90%',
      height: '50px'
    }),
    attrs: {
      "label": "修 改",
      "primary": ""
    },
    on: {
      "click": _vm.Change
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": ""
    },
    on: {
      "close": _vm.closeNO
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666",
      "margin-bottom": "1.5vh"
    }
  }, [_vm._v("\n      您真的要删除这条收藏吗？\n    ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#cccccc",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.closeNO
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#27BA69",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "label": "确定"
    },
    on: {
      "click": _vm.closeYES
    },
    slot: "actions"
  })], 1)])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9663f48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/ChangePassWord.vue
// module id = 1593
// module chunks = 18